/**
 * customClass.js
 */

// Import
import "./customClass.scss";
import $ from 'jquery';

$(document).ready(function() {

});

